import {createSlice} from "@reduxjs/toolkit";
import {isArray, isFunction} from "lodash";
import {firestore} from "../../config/firebaseConfig";

const slice = createSlice({
    name: 'container_details',
    initialState: {
        byCode: {},
        loading: false,
        error: null,
        notExist: [],
        hasQueried: []
    },
    reducers: {
        startLoading: state => {
            state.loading = true;
        },
        succeedRetrieving: (state, action) => {
            const {code, list} = action.payload;
            state.byCode[code] = list;
            state.loading = false;
        },
        hasError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            console.error(action.payload);
        },
        cantFindContainer: (state, action) => {
            state.loading = false;
            state.notExist = [...state.notExist, action.payload];
        },
        setHasQueried: (state, action) => {
            state.hasQueried = [...state.hasQueried, action.payload];
        }
    }
});

export default slice.reducer;

const {hasError, startLoading, succeedRetrieving, cantFindContainer, setHasQueried} = slice.actions;

export const selectContainerShipping = state => state.container;

export const fetchContainerDetails = (code, callback) => {
    return async (dispatch) => {
        try {

            dispatch(startLoading())

            dispatch(setHasQueried(code))

            const {docs} = await firestore.collection('shipping_orders')
                .where('ContainerCode', "==", code).get();

            const details = docs[0];

            if (details) {
                const {docs: subs, empty} = await firestore.collection('shipping_orders')
                    .doc(details.id)
                    .collection("Shippings_c")
                    .get();

                const firstList = isArray(details.Shippings) ? details.Shippings : [];
                const secondList = !empty ? subs.map(one => ({...one.data()})) : [];

                dispatch(succeedRetrieving({
                    code,
                    list: [...firstList, ...secondList]
                }));
            } else {
                dispatch(cantFindContainer(code))
            }

            isFunction(callback) && callback();

        } catch (error) {
            dispatch(hasError(error));
        }
    }
}

export const setNewArivals = (list = [], callback) => {
    return async (dispatch) => {
        try {

            dispatch(startLoading())

            const snap = await firestore.collection('arrivals').add({
                createdAt: new Date()
            });


            const subRef = snap.collection('list');


            let groups = [];
            let cursor = 400;
            let splitIndex = 0;

            while (list.length >= splitIndex) {
                if (list.length - cursor >= 0) {
                    groups.push(list.slice(splitIndex, cursor))
                } else {
                    let overIndex = cursor - list.length;
                    let restIndex = 400 - overIndex;
                    groups.push(list.slice(splitIndex, splitIndex + restIndex))
                    break;
                }

                splitIndex += 400;
                cursor += 400;
            }

            await Promise.all(groups.map(async (group) =>{
                const batch = firestore.batch();
                console.log(group)
                await Promise.all(group.map(async one=>{
                    const itemDc = await firestore.collection('items').doc(one.ProductId).get();
                    const doc = subRef.doc();
                    const data = {...one, Categorie: itemDc.data().Categorie}
                    batch.set(doc, data);
                }))

               await batch.commit();
            }))

            isFunction(callback) && callback();

        } catch (error) {
            dispatch(hasError(error));
        }
    }
}

